import SurveyCategoryItemInstruction from "./surveyCategoryItemInstruction";
import SurveyCategoryItemQuestion from "./surveyCategoryItemQuestion";

export default class SurveyCategoryItem {
  public idSurveyCategoryItem: number = 0;
  public idSurveyCategory: number = 0;
  public categoryItemName: string = "";
  public index: number = 0;
  public surveyCategoryItemInstructions: SurveyCategoryItemInstruction[] = [];
  public surveyCategoryItemQuestions: SurveyCategoryItemQuestion[] = [];
}
